module.exports = __webpack_public_path__ + "static/scale-model-of-russian-submarine-in-long-beach-california-86bb58ab8c488eb1a588a7ecdd530b5e.png";